import React from 'react'
import { Sidebar, FormMileage, MileagePlaceholder, ModalConfirm } from './'
import PropTypes from 'prop-types'
import { Alert } from 'loyal-react'
import ModalServices from '../Services/ModalServices/ModalServices'
import { SecondFactorAuthentication } from '../Checkout/SecondFactorAuthenticaton'
import '@loyal_template/services.css'

import TitlePrint from 'App/Shell/TitlePrint'

import { connect } from 'react-redux'
import { ToggleFeature, features } from 'features/ToggleFeature'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

const showError = (error, handlerCloseError) =>
  error ? (
    <Alert
      isError
      title={error.title ? error.title : 'Não foi possível concluir a sua transferência.'}
      description={error.description}
      className='pb-2'
      onClose={() => handlerCloseError()}
    />
  ) : (
    ''
  )
const VENDOR_ID_CONFIRM_MODAL = 758
const Mileage = ({
  isloading,
  isLoadingRedemption,
  partners,
  selectPartnersOnChange,
  inputPointsOnblur,
  pointsConverterOnblur,
  inputPointsOnChange,
  handlerFinalizePayment,
  handleConfirmationModal,
  confirmationModal,
  handlerCloseError,
  points,
  loadingPayment,
  showModal,
  closeterms,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  vendorId,
  miles,
  loyaltyNumber,
  inputLoyaltNumberOnChange,
  partnerName,
  errorRedemption,
  handleConvertAllPoints,
  convertAllPoints,
  disabledFields,
  handleFormatValue,
  currencyConfiguration,
  fidelityLabel,
  validateCPF,
  disableLoyaltyNumber,
  sendTwoFactorAuthorization,
  authorizeWithTokenMileage,
  authorizeWithTokenResend,
  authorizeWithTokenLastTry,
  loadingResendToken,
  closeModalShowError,
  oidc,
  disabledSelectPartner,
  disableRedemption,
  disableOnFocus,
  disableOnBlur,
  campaignId
}) => (
  <ReactPlaceholder
    ready={!isloading}
    customPlaceholder={<MileagePlaceholder />}
  >
    <TitlePrint page={'Transferência de pontos'} />
    <div className='container-fluid px-0 px-md-1 pt-0'>
      <div className='container pt-0 pb-3 py-md-5'>
        <div className='row pt-0'>
          {showError(errorRedemption, handlerCloseError)}
          {process.env.REACT_APP_ONBOARDING_ENDPOINT && campaignId
            ? (
              <div className='col-12 px-2 mt-2 mt-md-0 mb-1'>
                <p className='txt-body pb-1'>
                  Para garantir a transferência dos seus pontos com sucesso
                  certifique-se que você ativou a verificação em duas etapas.{' '}
                  <a
                    href={`${process.env.REACT_APP_ONBOARDING_ENDPOINT}${campaignId}`}
                    className='color-featured txt-bold'
                  >
                    Clique aqui para ativar.
                  </a>
                </p>
              </div>
            )
            : ''
          }
          <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '>
            <div className='row mx-0'>
              <div className='col-12 radius border border-color-ui-3'>
                <ToggleFeature feature={features.headerMileage} vendorId={vendorId} />
                <div className='row radius-bottom bg-white px-1'>
                  <div className='col-12 px-2 py-2'>
                    <p className='txt-body pb-1'>
                      Transfira seus pontos para os programas parceiros. Veja o
                      que você precisa saber:
                    </p>
                    <p className='txt-body-sm'>
                      • Verifique se possui uma conta no programa parceiro e se
                      os dados estão atualizados
                    </p>
                    <p className='txt-body-sm'>
                      • A transferência acontecerá para a mesma titularidade
                    </p>
                  </div>
                  <div className='col-12 px-3'>
                    <FormMileage
                      disableOnFocus={disableOnFocus}
                      miles={miles}
                      points={points}
                      partners={partners}
                      isloading={isloading}
                      inputPointsOnblur={inputPointsOnblur}
                      pointsConverterOnblur={pointsConverterOnblur}
                      inputPointsOnChange={inputPointsOnChange}
                      selectPartnersOnChange={selectPartnersOnChange}
                      inputLoyaltNumberOnChange={inputLoyaltNumberOnChange}
                      handleConvertAllPoints={handleConvertAllPoints}
                      convertAllPoints={convertAllPoints}
                      disabledFields={disabledFields}
                      handleFormatValue={handleFormatValue}
                      currencyConfiguration={currencyConfiguration}
                      fidelityLabel={fidelityLabel}
                      loyaltyNumber={loyaltyNumber}
                      validateCPF={validateCPF}
                      disableLoyaltyNumber={disableLoyaltyNumber}
                      partnerName={partnerName}
                      disabledSelectPartners={disabledSelectPartner}
                      disableOnBlur={disableOnBlur}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalServices
            title={'Termos do Regulamento de ' + partnerName}
            show={showModal}
            terms={{
              type: 'Vendor',
              vendorId: vendorId
            }}
            onClose={closeterms}
            acceptTerms={e => acceptTermsEvent(true)}
          />
          <div className='modalConfirmationVoucher'>
            <ModalConfirm
              show={confirmationModal}
              onClose={handleConfirmationModal}
              partner={partnerName}
              handlerFinalizePayment={handlerFinalizePayment}
              loadingPayment={loadingPayment}
            />
          </div>
          <Sidebar
            miles={miles}
            pointsValue={points}
            disableRedemption={disableRedemption}
            partnerName={partnerName}
            acceptTerms={acceptTerms}
            loyaltyNumber={loyaltyNumber}
            showTermsEvent={showTermsEvent}
            disabledFields={disabledFields}
            acceptTermsEvent={acceptTermsEvent}
            handleConfirmationModal={
              vendorId && vendorId === VENDOR_ID_CONFIRM_MODAL
                ? handleConfirmationModal
                : handlerFinalizePayment
            }
            currencyConfiguration={currencyConfiguration}
            handleFormatValue={handleFormatValue}
            fidelityLabel={fidelityLabel}
            isLoadingRedemption={isLoadingRedemption}
          />
          <div className='modalConfirmationVoucher'>
            {sendTwoFactorAuthorization && sendTwoFactorAuthorization.enable ? (
              <SecondFactorAuthentication
                show={
                  sendTwoFactorAuthorization.enable
                }
                onClose={() => this.toogleModal()}
                closeModal={() => {
                  closeModalShowError(
                    'Não foi possível concluir o seu pagamento.'
                  )
                }}
                secondFactorAuthConfirmated={
                  sendTwoFactorAuthorization.secondFactorAuthConfirmated
                }
                loadingResendToken={loadingResendToken}
                sendTwoFactorAuthorization={sendTwoFactorAuthorization}
                authorizeWithTokenMileage={authorizeWithTokenMileage}
                authorizeWithTokenResend={authorizeWithTokenResend}
                authorizeWithTokenLastTry={authorizeWithTokenLastTry}
                vendorId={vendorId}
                errorToken={sendTwoFactorAuthorization.errorToken}
                paymentSelected='POINTS_ONLY'
                isCreatingPurchase={isLoadingRedemption}
                oidc={oidc}
                phone={sendTwoFactorAuthorization.phone}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  </ReactPlaceholder>
)

Mileage.propTypes = {
  partners: PropTypes.array,
  selectPartnersOnChange: PropTypes.func,
  inputPointsOnblur: PropTypes.func,
  pointsConverterOnblur: PropTypes.func,
  inputPointsOnChange: PropTypes.func,
  isloading: PropTypes.bool,
  isLoadingRedemption: PropTypes.bool,
  loadingPayment: PropTypes.bool,
  handlerFinalizePayment: PropTypes.func,
  handleConfirmationModal: PropTypes.func,
  confirmationModal: PropTypes.bool,
  handlerCloseError: PropTypes.func,
  points: PropTypes.number,
  showModal: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  closeterms: PropTypes.func,
  acceptTerms: PropTypes.bool,
  acceptTermsEvent: PropTypes.func,
  vendorId: PropTypes.string,
  miles: PropTypes.number,
  inputLoyaltNumberOnChange: PropTypes.func,
  loyaltyNumber: PropTypes.number,
  partnerName: PropTypes.string,
  errorRedemption: PropTypes.string,
  handleConvertAllPoints: PropTypes.func,
  convertAllPoints: PropTypes.bool,
  disabledFields: PropTypes.bool,
  handleFormatValue: PropTypes.func,
  currencyConfiguration: PropTypes.object,
  fidelityLabel: PropTypes.string,
  validateCPF: PropTypes.func,
  disableLoyaltyNumber: PropTypes.bool,
  sendTwoFactorAuthorization: PropTypes.object,
  authorizeWithTokenMileage: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  loadingResendToken: PropTypes.bool,
  closeModalShowError: PropTypes.func,
  oidc: PropTypes.object,
  disabledSelectPartner: PropTypes.bool,
  disableRedemption: PropTypes.bool,
  disableOnFocus: PropTypes.func,
  disableOnBlur: PropTypes.func,
  campaignId: PropTypes.number
}
const mapStateToProps = ({ oidc }) => {
  return ({ campaignId: oidc && oidc.user && oidc.user.profile['custom:campaign_id'] })
}
export default connect(mapStateToProps)(Mileage)



// WEBPACK FOOTER //
// ./src/features/MileageRescue/Mileage.js